/* Judge.me reviews for the theme's own review cards (sections/customer-reviews.liquid, sections/jx-reviews.liquid).
   Judge.me stays the backend: reviews come from the same public endpoint Judge.me's widget uses, sorted highest rated
   first; verified buyers only by default (pass verifiedOnly: false for every review). 1-star reviews are always left out.
   Everything is turned into plain text here, so review content never runs as HTML.
   window.jxJudgeme.fetchPage({ shop, productId, page, perPage, verifiedOnly = true, sort = 'rating', dir = 'desc' }) -> Promise<{ reviews, page, pages }>
   sort 'pictures' asks Judge.me for photo reviews first (sort_by=pictures_first); dir 'asc' reverses the order (lowest rated first).
   Judge.me serves at most 33 pages of 30 per order, so on a product with more reviews the two directions together reach them all.
   The review sections start fetching as soon as the page loads, so reviews are in place before anyone scrolls to them.
   The same request made twice on a page (two review sections, pins and photo phases) is sent once and shared.
   Each answer is also kept in sessionStorage for 10 minutes, so further pages in the same visit show reviews without waiting on Judge.me. */
(function () {
  if (window.jxJudgeme) return;
  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var dateFmt;
  try { dateFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { dateFmt = null; }

  function paragraphs(html) {
    var doc = new DOMParser().parseFromString('<body>' + (html || '') + '</body>', 'text/html');
    var blocks = Array.prototype.slice.call(doc.body.querySelectorAll('p'));
    var list = (blocks.length ? blocks : [doc.body]).map(function (p) { return (p.textContent || '').replace(/\s+/g, ' ').trim(); });
    return list.filter(Boolean);
  }
  function photo(r) {
    var p = (r.pictures_urls || [])[0];
    if (!p) return '';
    return typeof p === 'string' ? p : (p.compact || p.small || p.original || '');
  }
  function normalize(r) {
    var d = r.created_at ? new Date(r.created_at) : null;
    return {
      id: r.uuid,
      rating: Math.max(0, Math.min(5, Number(r.rating) || 0)),
      verified: !!r.verified_buyer,
      name: (r.reviewer_name || '').trim(),
      location: (r.location || '').trim(),
      title: (r.title || '').trim(),
      body: paragraphs(r.body_html),
      date: d && !isNaN(d) && dateFmt ? dateFmt.format(d) : '',
      photo: photo(r)
    };
  }
  var pending = {};
  var CACHE = 'jx-jm:', TTL = 10 * 60 * 1000;
  function cached(url) { /* a saved answer under 10 minutes old, or nothing */
    try {
      var hit = JSON.parse(sessionStorage.getItem(CACHE + url));
      if (hit && Date.now() - hit.t < TTL) return hit.v;
      sessionStorage.removeItem(CACHE + url);
    } catch (e) {}
    return null;
  }
  function save(url, v) {
    var item = JSON.stringify({ t: Date.now(), v: v });
    try { sessionStorage.setItem(CACHE + url, item); return; } catch (e) {}
    try { /* storage full: drop expired answers and try once more */
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(CACHE) === 0) { var old = JSON.parse(sessionStorage.getItem(k)); if (!old || Date.now() - old.t >= TTL) sessionStorage.removeItem(k); }
      }
      sessionStorage.setItem(CACHE + url, item);
    } catch (e) {}
  }
  function fetchPage(o) {
    var verifiedOnly = o.verifiedOnly !== false;
    var q = new URLSearchParams({
      url: o.shop, shop_domain: o.shop, platform: 'shopify', product_id: o.productId,
      page: o.page || 1, per_page: o.perPage || 30, sort_by: o.sort === 'pictures' ? 'pictures_first' : 'rating', sort_dir: o.dir === 'asc' ? 'asc' : 'desc'
    });
    if (verifiedOnly) q.set('verified_only', 'true');
    var url = API + '?' + q.toString();
    if (pending[url]) return pending[url];
    var hit = cached(url);
    if (hit) return (pending[url] = Promise.resolve(hit));
    var req = fetch(url, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('Judge.me ' + res.status); return res.json(); })
      .then(function (d) {
        var pg = d.pagination || {};
        return {
          /* 1-star reviews are never shown on the store */
          reviews: (d.reviews || []).filter(function (r) { return (!verifiedOnly || r.verified_buyer) && Number(r.rating) > 1; }).map(normalize),
          page: pg.current_page || o.page || 1,
          pages: pg.total_pages || 1
        };
      })
      .then(function (v) { save(url, v); return v; });
    pending[url] = req;
    req.catch(function () { delete pending[url]; }); /* a failed request can be tried again */
    return req;
  }
  /* Review body as text with <br> between paragraphs */
  function fillBody(el, lines) {
    el.textContent = '';
    lines.forEach(function (line, i) {
      if (i) { el.appendChild(document.createElement('br')); el.appendChild(document.createElement('br')); }
      el.appendChild(document.createTextNode(line));
    });
  }
  window.jxJudgeme = { fetchPage: fetchPage, fillBody: fillBody };
  document.dispatchEvent(new CustomEvent('jx:judgeme:ready'));
})();
